import { Box, Spinner, Text } from '@nimbus-ds/components';
import { NewLineToBr } from 'commons/components';
import { useGetWhatsappTemplateByIdQuery } from 'domains/Configurations/Notifications/notificationsApi';

export function WhatsAppPreview({ templateId }: { templateId: string }) {
  const { data: templateData, isLoading } =
    useGetWhatsappTemplateByIdQuery(templateId);

  if (isLoading && !templateData) {
    return <Spinner />;
  }

  if (!templateData) {
    return null;
  }

  const bodyComponent = templateData.content.components.find(
    (component) => component.type === 'BODY',
  );
  const bodyText = bodyComponent?.text || '';

  const buttonsComponent = templateData.content.components.find(
    (component) => component.type === 'BUTTONS',
  );
  const buttonText = buttonsComponent?.buttons?.[0]?.text || '';

  return (
    <Box
      width="400px"
      height="auto"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      borderRadius="base"
      borderColor="neutral-interactive"
      borderWidth="1"
      borderStyle="solid"
      backgroundColor="neutral-background"
      padding="3"
      textAlign="center"
      gap="2-5"
    >
      <Text textAlign="left" fontSize="highlight" color="neutral-textHigh">
        <NewLineToBr text={bodyText} />
      </Text>
      <Box
        width="100%"
        height="auto"
        borderStyle="solid"
        borderColor="neutral-surfaceHighlight"
        borderWidth="none"
        borderTopWidth="1"
        paddingTop="3"
      >
        <Text
          textAlign="center"
          fontSize="highlight"
          color="primary-interactive"
        >
          {buttonText}
        </Text>
      </Box>
    </Box>
  );
}
